import * as tslib_1 from "tslib";
import moment from 'moment';
import { Component } from "vue-property-decorator";
import { DateInputControl } from '../../controls';
import { dateFormatter } from "../../utils/date-formatter";
import { DatePicker } from '@h3/antd-vue';
let InputDateRange = class InputDateRange extends DateInputControl {
    constructor() {
        super(...arguments);
        this.dates = [];
        this.open = false;
    }
    get getMode() {
        let displayFormat = this.control.options.displayFormat || '';
        switch (Number(displayFormat)) {
            case 4:
                return ['month', 'month'];
            case 5:
                return ['year', 'year'];
            default:
                return [];
        }
    }
    get getShowTime() {
        let displayFormat = this.control.options.displayFormat || '';
        switch (Number(displayFormat)) {
            case 2:
                return { format: 'HH:mm:ss' };
            case 3:
                return { format: 'HH:mm' };
            case 4:
                return false;
            case 9:
                return { format: 'HH:mm' };
            case 10:
                return { format: 'HH:mm' };
            case 11:
                return { format: 'HH:mm' };
            case 12:
                return { format: 'HH:mm' };
            default:
                return false;
        }
    }
    get getFormat() {
        let displayFormat = this.control.options.displayFormat || '';
        switch (Number(displayFormat)) {
            case 2:
                return 'YYYY-MM-DD HH:mm:ss';
            case 3:
                return 'YYYY-MM-DD HH:mm';
            case 4:
                return "YYYY-MM";
            case 5:
                return "YYYY";
            case 6:
                return "MM-DD";
            case 7:
                return "HH:mm";
            case 8:
                return "HH:mm:ss";
            case 9:
                return "YYYY-MM-DD HH:mm";
            case 10:
                return "YYYY-MM-DD HH:mm";
            case 11:
                return "YYYY-MM-DD HH:mm";
            case 12:
                return "YYYY-MM-DD HH:mm";
            default:
                return "YYYY-MM-DD";
        }
    }
    get getRanges() {
        let displayFormat = this.control.options.displayFormat || '';
        switch (Number(displayFormat)) {
            case 4:
                return {
                    '本月': [moment().startOf('month'), moment().endOf('month')],
                    '上月': [moment().month(moment().month() - 1).startOf('month'), moment().month(moment().month() - 1).endOf('month')],
                    '本季度': [moment().startOf('quarter'), moment().endOf('quarter')],
                    '本年度': [moment().startOf('year'), moment().endOf('year')]
                };
            case 5:
                return {
                    '本年度': [moment().startOf('year'), moment().endOf('year')]
                };
            default:
                return {
                    '当天': [moment().startOf('days'), moment().endOf('days')],
                    '昨天': [moment().add(-1, 'days').startOf('days'), moment().add(-1, 'days').endOf('days')],
                    '本周': [moment().startOf('week'), moment().endOf('week')],
                    '上周': [moment().week(moment().week() - 1).startOf('week'), moment().week(moment().week() - 1).endOf('week')],
                    '本月': [moment().startOf('month'), moment().endOf('month')],
                    '上月': [moment().month(moment().month() - 1).startOf('month'), moment().month(moment().month() - 1).endOf('month')],
                    '本季度': [moment().startOf('quarter'), moment().endOf('quarter')],
                    '本年度': [moment().startOf('year'), moment().endOf('year')]
                };
        }
    }
    get disabled() {
        return !(this.dates[0] && this.dates[1]);
    }
    setDates() {
        if (this.ctrl && this.ctrl.value) {
            this.dates = this.ctrl.value.map((s) => {
                if (s) {
                    return moment(s);
                }
                return s;
            });
        }
        else {
            this.dates = [];
        }
    }
    setControl() {
        this.setDates();
    }
    handleValueChange(value) {
        this.setDates();
    }
    onChange(dates, dateStrings) {
        this.ctrl.value = dateStrings && dateStrings.length > 0 ? dateStrings : null;
    }
    onPanelChange(value, mode) {
        this.ctrl.value = value.map((v) => {
            return dateFormatter(v._d, this.getFormat);
        });
        this.setDates();
    }
    onOpenChange(status) {
        if (status) {
            this.open = true;
        }
        else {
            this.open = false;
        }
    }
    handleFooterBtn() {
        this.open = false;
    }
};
InputDateRange = tslib_1.__decorate([
    Component({
        name: "input-date-range",
        components: {
            ARangePicker: DatePicker.RangePicker
        }
    })
], InputDateRange);
export default InputDateRange;
